import ProfileCard from "../../components/ProfileCard";

export default function ProfileCardPage() {
    return (
        <ProfileCard />
    )
};